<template>
  <el-dialog
    :visible="true"
    :fullscreen="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div slot="title">
      {{ title }}
      <el-tag
        v-if="representativeDrop.status && type === 'update'"
        size="small"
        :type="getStatus().tag"
        style="margin-left: 5px;"
      >
        {{ getStatus().label }}
      </el-tag>
    </div>
    <div v-loading="loading">
      <el-form
        ref="dropForm"
        label-position="top"
        :model="representativeDrop"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              prop="supplier"
              label="Átadó"
            >
              <el-input
                v-model="representativeDrop.supplier.full_name"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="sourceStorage"
              label="Szállító raktár"
            >
              <el-input
                v-model="representativeDrop.source_storage.name"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="customer"
              label="Átvevő"
            >
              <el-select
                v-model="representativeDrop.customer"
                style="width: 100%;"
                value-key="id"
                filterable
                :disabled="true"
              >
                <el-option
                  v-for="customer in customers"
                  :key="customer.id + 'customer'"
                  :value="customer"
                  :label="customer.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="target_storage"
              label="Átvevő raktár"
            >
              <el-select
                v-model="representativeDrop.target_storage"
                style="width: 100%;"
                value-key="id"
                filterable
                :disabled="true"
              >
                <el-option
                  v-for="storage in storages"
                  :key="storage.id"
                  :value="storage"
                  :label="storage.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="display: flex; align-items: center">
          <el-col :span="6">
            <el-form-item
              prop="cm_delivery_note_number"
              label="CM szlev száma"
            >
              <el-input
                v-model="representativeDrop.cm_delivery_note_number"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="receipt_number"
              label="Bizonylatszám"
            >
              <el-input
                v-model="representativeDrop.receipt_number"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="currency"
              label="Deviza"
            >
              <el-input
                v-model="representativeDrop.currency.name"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Rögzítette"
              prop="creator_user"
            >
              <el-input
                v-model="representativeDrop.creator_user.full_name"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label=""
              prop="is_stockist"
              style="margin-bottom: 20px;"
            >
              <el-checkbox
                v-model="representativeDrop.is_stockist"
              >
                Beszerzési árak véglegesek
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <product-items
          ref="productItems"
          :load-base-count-from-stock="false"
          :is-product-select-from-stock="false"
          :default-items="representativeDrop.order_items"
          :enabled-elements="enabledElements"
          :enabled-columns="['product', 'supplierSelector', 'productPackType', 'expirationDateSelector', 'count', 'purchaseUnitPrice', 'vat', 'actions']"
          @priceChange="onPriceChange"
        />
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        v-if="representativeDrop.status !== 'recorded' && representativeDrop.receipt_file"
        @click="openReceipt"
      >
        Bizonylat nyomtatása
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import ProductItems from '../../utils/ProductItems/index';

  export default {
    components: {
      ProductItems,
    },
    props: ['type', 'representativeDropId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        representativeDrop: {
          status: 'dropped',
          net_price: 0,
          gross_price: 0,
          order_items: [],
          customer: null,
          supplier: {},
          creator_user: {},
          source_storage: {},
          target_storage: {},
          currency: {},
          is_stockist: false,
          cm_delivery_note_number: '',
        },

        rules: {
          cm_delivery_note_number: [
            {
              max: 255,
              message: 'A CM szállítólevél szám maximális hossza 255 karakter',
              trigger: 'blur'
            }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új képviselői termék leadás';
        } else if (this.type === 'update') {
          return 'Képviselői termékleadás módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
      enabledElements() {
        switch (this.representativeDrop.status) {
          case 'recorded':
            return ['addButton', 'deleteButton', 'product', 'pack', 'count', 'purchaseUnitPrice', 'vat', 'expirationDateSelector', 'supplierSelector'];
          case 'done':
            return this.representativeDrop.is_stockist ? [] : ['purchaseUnitPrice'];
          case 'dropped':
            return this.representativeDrop.is_stockist ? [] : ['purchaseUnitPrice'];
          default:
            return [];
        }
      },
      suppliers() {
        return this.$store.getters['user/users'];
      },
      customers() {
        return this.$store.getters['ownCompany/ownCompanies'];
      },
      storages() {
        return this.$store.getters['storage/ownStorages'];
      },
      currencies() {
        return this.$store.getters['currency/currencies'];
      },
    },
    async mounted() {
      this.loading = true;
      const requiredFetches = [];
      if (this.representativeDropId) {
        requiredFetches.push(this.$store.dispatch('representativeDrop/fetch', this.representativeDropId));
      }
      if (!this.customers.length) {
        requiredFetches.push(this.$store.dispatch('ownCompany/fetchAll', ''));
      }
      if (!this.storages.length) {
        requiredFetches.push(this.$store.dispatch('storage/fetchAll', ''));
      }
      if (!this.currencies.length) {
        requiredFetches.push(this.$store.dispatch('currency/fetchAll'));
      }
      if (!this.suppliers.length) {
        requiredFetches.push(this.$store.dispatch('user/fetchAll'));
      }
      const [drop] = await Promise.all(requiredFetches);
      if (this.representativeDropId) {
        this.representativeDrop = drop;
      }
      this.loading = false;
    },
    methods: {
      async store() {
        this.$refs.dropForm.validate(async valid => {
          if (valid) {
            this.representativeDrop.order_items = this.$refs['productItems'].getItems();
            if (!this.representativeDrop.order_items.length) {
              return this.$messageWrapper.warning('Minimum 1 termék hozzáadása kötelező.');
            }
            this.buttonLoading = true;
            try {
              await this.$store.dispatch('representativeDrop/update', this.representativeDrop);
              this.$store.dispatch('representativeDrop/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/representative-processes/representative-drops');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      },
      onPriceChange({ netPrice, grossPrice }) {
        this.representativeDrop.net_price = netPrice;
        this.representativeDrop.gross_price = grossPrice;
      },
      handleClose() {
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/representative-processes/representative-drops');
        })
        .catch(() => {
        });
      },
      openReceipt() {
        if (this.representativeDrop.receipt_file) {
          window.open(this.representativeDrop.receipt_file);
        }
      },
      getStatus() {
        switch (this.representativeDrop.status) {
          case 'done':
            return {
              label: 'Átvéve',
              tag: 'success',
            };
          case 'dropped':
            return {
              label: 'Átvételre vár',
              tag: 'info',
            };
          case 'cancelled':
            return {
              label: 'Visszavonva',
              tag: 'danger',
            };
        }
      },
    },
  };
</script>

<style lang="scss">
  .price-sum {
    margin-top: 20px;
    text-align: right;
    font-size: 18px;

    > div {
      display: inline-block;
    }
  }
</style>
